var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"c-claims app-bg"},[_c('v-layout',{attrs:{"column":""}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.value)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }